<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12 mb-4">
        <div class="card">
          <div class="card-header pb-0">
            <h6>검색필터</h6>
          </div>
          <div class="card-body"> 
            <div class="row">
              <div class="col-4 mb-4"><input type="type" class="form-control" v-model="search_email" placeholder="관리자 이메일을 입력해주세요." @keyup="SearchList()"/></div>
              <div class="col-4 mb-4"><button class="btn mb-0 btn-primary" data-bs-toggle="modal" data-bs-target="#add_admin">관리자 추가</button></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <h6>관리자 정보</h6>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">아이디</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">상태</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">권한</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">상세정보</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="list.length ==0">
                    <td colspan="3" class="text-center">검색하신데이터가 없습니다.</td>
                  </tr>
                  <tr v-for="(item,index) in list" :key="index">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{item.email}}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{CheckStatus(item.status)}}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-sm">{{CheckAuth(item.auth)}}</h6>
                      </div>
                    </td>
                    
                     
                    <td class="align-middle text-left text-sm">
                      <span class="badge badge-lg bg-gradient-success" @click="Detail(item.code)">상세보기</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              
            </div>
            <hr class="horizontal dark" />
            <ul class="pagination pagination-primary pagination-sm d-flex justify-content-center">
              <li class="page-item" v-if="max_page > 5">
                <a class="page-link" href="javascript:void(0);" @click="PrevPage()">
                  <i class="fa fa-angle-left"></i>
                </a>
              </li>
              <li class="page-item " :class="CheckPage(n)" v-for="n in max_page" :key="'Page_'+n">
                <a class="page-link" href="javascript:void(0);"  @click="ClickPaging(n)">
                  {{n}}
                </a>
              </li>
              <li class="page-item"  v-if="max_page > 5" >
                <a class="page-link" href="javascript:void(0);" @click="NextPage()">
                  <i class="fa fa-angle-right"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" tabindex="-1" id="add_admin">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">관리자 추가</h5>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">X</button>
          </div>
          <div class="modal-body">
            <label for="example-text-input" class="form-control-label">아이디</label>
            <input type="type" class="form-control" v-model="add_email" placeholder="관리자 아이디를 입력해주세요." />
            <label for="example-text-input" class="form-control-label">권한</label>
            <select class="form-select" v-model="add_auth">
              <option value="" style="display:none">관리자 권한을 선택해주세요.</option>
              <option :value="item.auth"  v-for="(item,index) in auth_list" :key="index">{{item.title}}</option>
            </select>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">취소</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="AddAdmin()">추가</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const exactMath = require('exact-math');
import { mapMutations } from "vuex";
const CryptoJS = require("crypto-js");
export default {
  name: "tables",
  components: {
    
  },
  data() {
    return {
      search_email : '',
      limit : 10,
      page : 1,
      max_page : 0,
      show : 3,
      add_email : '',
      add_auth : '',
      auth :  this.$store.state.auth,
      auth_list : [],
      list : [],
      path : '',
      mobile :this.$store.state.mobile,
      show_mobile :this.$store.state.show_mobile,
      
    };
  },
  mounted(){
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    this.$store.state.isAbsolute = false;
    this.GetCommonAuthList();
    if(this.mobile ==true){
      if(this.show_mobile ==true){
        this.navbarMinimize();
      } 
    }
    
    this.GetAdminList();
  },
  methods:{
    ...mapMutations(["navbarMinimize"]),
    CheckAuth(auth){
      var text = '';
      for (const el of this.auth_list) {
        if(el.auth ==auth){
          text = el.title;
        }
      }

      return text;
    },
    CheckStatus(status){
      if(status =='Y'){
        return "접속가능"
      }else if(status =='H'){
        return "인증대기"
      }else if(status =='C'){
        return "차단"
      }

    },
    ClickPaging(i){
      this.page =i;
      this.GetAdminList();
    },
    CheckPage(i){
      
      const show = this.show;
      const page = this.page;
      var add_class ='';
      if((i+2) == show){
        if(page ==i){
          add_class = " active ";
        }
        
      }else if((i+1) == show){
        if(page ==i){
          add_class = " active ";
        }
        
      }else if((i) == show){
        if(page ==i){
          add_class = " active ";
        }
        
      }else if((i-1) == show){
        if(page ==i){
          add_class = " active ";
        }
        
      }else if((i-2) == show){
        if(page ==i){
          add_class = " active ";
        }
      }else{
        add_class += 'd-none';
      }


      return add_class;

    },
    PrevPage(){
      const show = this.show;
      const show_prev = exactMath.sub(show,1);

      if(show_prev >= 3){
        this.show = show_prev;
      }else{
        this.show = show;
      }
    },
    NextPage(){
      const show = this.show;
      const show_next = exactMath.add(show,1);
      const max = exactMath.sub(this.max_page,2);

      if(show_next <= max){
        this.show = show_next;
      }else{
        this.show = max;
      }
    },
    SearchList(){
      this.page = 1;
      this.show = 3;
      this.GetAdminList();
    },
    GetCommonAuthList(){
      this.axios.post('/admin/admin/AuthList', {}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              const e_body = res.data.body;
              const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
              const d_res = bytes.toString(CryptoJS.enc.Utf8);
              const body = JSON.parse(d_res)
              this.auth_list = body.list;
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    GetAdminList(){
      const page = this.page;
      const email = this.search_email;
      const limit = this.limit;

      const body = {page,email,limit};
      
			const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();
      this.axios.post('/admin/admin/AdminList', {req}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.max_page = res.data.count;
              const e_body = res.data.body;
              const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
              const d_res = bytes.toString(CryptoJS.enc.Utf8);
              const body = JSON.parse(d_res);
              this.list = body.list;
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    ResetAddForm(){
      this.add_email ='';
      this.add_auth ='';
    },
    AddAdmin(){
      const email = this.add_email;
      const auth = this.add_auth;

      const body = {email,auth};
      const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();

      this.axios.post('/admin/admin/AddAdmin', {req}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.$alert.alert("관리자를 추가하였습니다.");
              this.ResetAddForm()
              this.SearchList();
            }else if(res.data.code=='100'){
              this.$alert.alert("관리자 아이디가 있습니다.");
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    Detail(no){
      this.$router.push({path:`/admin/${no}`})
    }
  }
};
</script>
